var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 6.66797C5.54738 6.66797 6.66667 5.54868 6.66667 4.16797C6.66667 2.78726 5.54738 1.66797 4.16667 1.66797C2.78595 1.66797 1.66667 2.78726 1.66667 4.16797C1.66667 5.54868 2.78595 6.66797 4.16667 6.66797Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 12.5C17.214 12.5 18.3333 11.3807 18.3333 10C18.3333 8.61929 17.214 7.5 15.8333 7.5C14.4526 7.5 13.3333 8.61929 13.3333 10C13.3333 11.3807 14.4526 12.5 15.8333 12.5Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 18.332C5.54738 18.332 6.66667 17.2127 6.66667 15.832C6.66667 14.4513 5.54738 13.332 4.16667 13.332C2.78595 13.332 1.66667 14.4513 1.66667 15.832C1.66667 17.2127 2.78595 18.332 4.16667 18.332Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30833 10.0013H7.5C5.66667 10.0013 4.16667 9.16797 4.16667 6.66797V13.3346",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchh);
export default __webpack_public_path__ + "static/media/branchh.c225576fc1470ba8356d79b9e67a71df.svg";
export { ForwardRef as ReactComponent };